// action types
import { createRequestTypes } from "../../utils";

// Organization CRUD
export const GET_MY_ORGANIZATION = createRequestTypes("GET_MY_ORGANIZATION");
export const CREATE_ORGANIZATION = createRequestTypes("CREATE_ORGANIZATION");
export const UPDATE_ORGANIZATION = createRequestTypes("UPDATE_ORGANIZATION");
export const DELETE_ORGANIZATION = createRequestTypes("DELETE_ORGANIZATION");

// Member management
export const INVITE_MEMBER = createRequestTypes("INVITE_MEMBER");
export const ACCEPT_INVITATION = createRequestTypes("ACCEPT_INVITATION");
export const REJECT_INVITATION = createRequestTypes("REJECT_INVITATION");
export const GET_MEMBERS = createRequestTypes("GET_MEMBERS");
export const CHANGE_MEMBER_ROLE = createRequestTypes("CHANGE_MEMBER_ROLE");
export const REMOVE_MEMBER = createRequestTypes("REMOVE_MEMBER");

// Available Roles
export const GET_AVAILABLE_ROLES = createRequestTypes("GET_AVAILABLE_ROLES");

// UI state
export const SET_SELECTED_ORGANIZATION = 'SET_SELECTED_ORGANIZATION';
export const RESET_ORGANIZATION_STATE = 'RESET_ORGANIZATION_STATE';

// ----------------------------------------------------------------------
// Action Creators - Organization CRUD
// ----------------------------------------------------------------------

export const getMyOrganizationRequest = () => ({
  type: GET_MY_ORGANIZATION.REQUEST,
});

export const getMyOrganizationSuccess = (data) => ({
  type: GET_MY_ORGANIZATION.SUCCESS,
  payload: { data },
});

export const getMyOrganizationFailure = (error) => ({
  type: GET_MY_ORGANIZATION.FAILURE,
  payload: error,
});

export const createOrganizationRequest = (data) => ({
  type: CREATE_ORGANIZATION.REQUEST,
  payload: data,
});

export const createOrganizationSuccess = (data) => ({
  type: CREATE_ORGANIZATION.SUCCESS,
  payload: { data },
});

export const createOrganizationFailure = (error) => ({
  type: CREATE_ORGANIZATION.FAILURE,
  payload: error,
});

export const updateOrganizationRequest = (id, data) => ({
  type: UPDATE_ORGANIZATION.REQUEST,
  payload: { id, data },
});

export const updateOrganizationSuccess = (data) => ({
  type: UPDATE_ORGANIZATION.SUCCESS,
  payload: { data },
});

export const updateOrganizationFailure = (error) => ({
  type: UPDATE_ORGANIZATION.FAILURE,
  payload: error,
});

export const deleteOrganizationRequest = (id) => ({
  type: DELETE_ORGANIZATION.REQUEST,
  payload: id,
});

export const deleteOrganizationSuccess = (id) => ({
  type: DELETE_ORGANIZATION.SUCCESS,
  payload: { id },
});

export const deleteOrganizationFailure = (error) => ({
  type: DELETE_ORGANIZATION.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// Action Creators - Member Management
// ----------------------------------------------------------------------

export const inviteMemberRequest = (organizationId, email, roleId) => ({
  type: INVITE_MEMBER.REQUEST,
  payload: { organizationId, email, roleId },
});

export const inviteMemberSuccess = (data) => ({
  type: INVITE_MEMBER.SUCCESS,
  payload: { data },
});

export const inviteMemberFailure = (error) => ({
  type: INVITE_MEMBER.FAILURE,
  payload: error,
});

export const acceptInvitationRequest = (token) => ({
  type: ACCEPT_INVITATION.REQUEST,
  payload: token,
});

export const acceptInvitationSuccess = (data) => ({
  type: ACCEPT_INVITATION.SUCCESS,
  payload: { data },
});

export const acceptInvitationFailure = (error) => ({
  type: ACCEPT_INVITATION.FAILURE,
  payload: error,
});

export const rejectInvitationRequest = (token) => ({
  type: REJECT_INVITATION.REQUEST,
  payload: token,
});

export const rejectInvitationSuccess = () => ({
  type: REJECT_INVITATION.SUCCESS,
});

export const rejectInvitationFailure = (error) => ({
  type: REJECT_INVITATION.FAILURE,
  payload: error,
});

export const getMembersRequest = (organizationId) => ({
  type: GET_MEMBERS.REQUEST,
  payload: organizationId,
});

export const getMembersSuccess = (data) => ({
  type: GET_MEMBERS.SUCCESS,
  payload: { data },
});

export const getMembersFailure = (error) => ({
  type: GET_MEMBERS.FAILURE,
  payload: error,
});

export const changeMemberRoleRequest = (organizationId, memberId, roleId) => ({
  type: CHANGE_MEMBER_ROLE.REQUEST,
  payload: { organizationId, memberId, roleId },
});

export const changeMemberRoleSuccess = (data) => ({
  type: CHANGE_MEMBER_ROLE.SUCCESS,
  payload: { data },
});

export const changeMemberRoleFailure = (error) => ({
  type: CHANGE_MEMBER_ROLE.FAILURE,
  payload: error,
});

export const removeMemberRequest = (organizationId, memberId) => ({
  type: REMOVE_MEMBER.REQUEST,
  payload: { organizationId, memberId },
});

export const removeMemberSuccess = (memberId) => ({
  type: REMOVE_MEMBER.SUCCESS,
  payload: { memberId },
});

export const removeMemberFailure = (error) => ({
  type: REMOVE_MEMBER.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// Action Creators - Available Roles
// ----------------------------------------------------------------------

export const getAvailableRolesRequest = () => ({
  type: GET_AVAILABLE_ROLES.REQUEST,
});

export const getAvailableRolesSuccess = (data) => ({
  type: GET_AVAILABLE_ROLES.SUCCESS,
  payload: { data },
});

export const getAvailableRolesFailure = (error) => ({
  type: GET_AVAILABLE_ROLES.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// UI State Actions
// ----------------------------------------------------------------------

export const setSelectedOrganization = (organization) => ({
  type: SET_SELECTED_ORGANIZATION,
  payload: organization,
});

export const resetOrganizationState = () => ({
  type: RESET_ORGANIZATION_STATE,
});
